var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _vm.validate === 1
      ? _c("div", { staticClass: "row my-4 text-center" }, [
          _c(
            "div",
            { staticClass: "col-md-12" },
            [
              _c("h3", [
                _vm._v("กดปุ่ม LINE ด้านล่างนี้เพื่อติดต่อเจ้าหน้าที่")
              ]),
              _vm._v(" "),
              _vm.isLineUser
                ? [_vm._m(0), _vm._v(" "), _vm._m(1)]
                : [
                    _vm.apiUrl
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-success btn-lg",
                            attrs: { href: _vm.apiUrl, target: "_blank" }
                          },
                          [
                            _c("i", { staticClass: "fab fa-line fa-lg" }),
                            _vm._v(" เชื่อมต่อกับ LINE\n        ")
                          ]
                        )
                      : _vm._e()
                  ]
            ],
            2
          )
        ])
      : _vm.validate === 0
      ? _c("div", { staticClass: "row my-4 text-center" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _vm._v("\n      ระบบกำลังทำการตรวจสอบ กรุณารอสักครู่...\n    ")
          ])
        ])
      : _c("div", { staticClass: "row my-4 text-center" }, [
          _c("div", { staticClass: "col-md-12 text-danger" }, [
            _vm._v(
              "\n      เกิดข้อผิดพลาด กรุณาแจ้งแอดมินเพื่อทำการตรวจสอบค่ะ\n    "
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticClass: "btn btn-success btn-lg",
        attrs: { href: "https://line.me/R/ti/p/%40beneatpro" }
      },
      [
        _c("i", { staticClass: "fab fa-line fa-lg" }),
        _vm._v(" เชื่อมต่อกับ LINE\n        ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "mt-4" }, [
      _c("h4", [
        _vm._v("ผู้สมัครได้เคยทำการเชื่อมต่อกับ LINE เรียบร้อยแล้วค่ะ")
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2914d47e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2914d47e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/LineProviderLogin.vue
// module id = 1642
// module chunks = 0